import { differenceInCalendarDays } from "date-fns";
import { DateTime } from "luxon";

import { PerkStatus } from "../../types";

export const hackerAPIDateToDueDate = (value: string | null) => {
  if (value === null) return "";

  const date = DateTime.fromISO(value);
  const isInFiveDays = date <= DateTime.now().plus({ days: 5 });
  if (isInFiveDays) {
    return date.toRelativeCalendar();
  }

  // Only show month and day (e.g., "May 21")
  return date.toLocaleString({ month: "short", day: "numeric" });
};

export const isInFiveDays = (value: string | null) => {
  if (value === null) return false;

  const date = DateTime.fromISO(value);
  return date <= DateTime.now().plus({ days: 5 });
};

export const getDaysUntilDueDate = (value: string | null): number | null => {
  if (!value) return null;
  return differenceInCalendarDays(new Date(value), new Date());
};

type LabelColor =
  | "success-light"
  | "warning-light"
  | "danger-light"
  | undefined;

export const getDueColor = (daysUntilDue: number | null): LabelColor => {
  if (typeof daysUntilDue !== "number") return undefined;
  if (daysUntilDue > 10) return "success-light";
  if (daysUntilDue >= 5) return "warning-light";
  return "danger-light";
};

export const getDueDateBadge = (value: string | null): string => {
  const label = hackerAPIDateToDueDate(value);
  return value ? `Due ${label}` : "";
};

export const perkStatusToBadgeColor = (status: PerkStatus) => {
  switch (status) {
    case PerkStatus.INCOMPLETE:
      return "secondary";
    case PerkStatus.APPROVED:
      return "success";
    case PerkStatus.SUBMITTED:
      return "primary";
    default:
      return "secondary";
  }
};

export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);
